/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';
import { Icon } from '@iconify/react';
import { useFormik, Form, FormikProvider } from 'formik';
import saveIcon from '@iconify/icons-eva/save-outline';

// material
import { Stack, FormControl, FormLabel, RadioGroup, Radio, FormControlLabel } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { useDispatch, useSelector } from 'react-redux';
import { useSnackbar } from 'notistack';
import { editItem } from '../../fetch';
import { sessionActions } from '../../store';
import { useTranslation } from '../../common/LocalizationProvider';
import { selectSession } from '../../createSelectorUtils';

// ----------------------------------------------------------------------
// components

export default function UnitsChose() {
  const t = useTranslation();
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const session = useSelector(selectSession);

  const formik = useFormik({
    initialValues: session,
    onSubmit: async (values) => {
      const body = { ...values };
      delete body.permission;

      const response = await editItem('users', session.id, body);
      if (response.ok) {
        enqueueSnackbar(t('profile_Changed'), {
          variant: 'success'
        });
        const result = await response.json();
        dispatch(sessionActions.update(await result));
      } else {
        const error = await response.text();
        const message = error.slice(0, error.indexOf('-'));
        enqueueSnackbar(message, { variant: 'error' });
      }

      setSubmitting(false);
    }
  });
  const { handleSubmit, isSubmitting, getFieldProps, setSubmitting } = formik;

  return (
    <FormikProvider value={formik}>
      <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
        <Stack spacing={3}>
          <Stack direction="row" spacing={4}>
            <FormControl fullWidth>
              <FormLabel id="speed-radio-buttons-group-label">{t('LM_Speed')}</FormLabel>
              <RadioGroup
                aria-labelledby="speed-radio-buttons-group-label"
                name="speed-radio-buttons-group"
                {...getFieldProps('uniteVitesse')}
                value={getFieldProps('uniteVitesse').value || ''}
              >
                <FormControlLabel value="km/h" control={<Radio />} label="km/h" />
                <FormControlLabel value="kt" control={<Radio />} label="kt" />
              </RadioGroup>
            </FormControl>

            <FormControl fullWidth>
              <FormLabel id="altitude-radio-buttons-group-label">
                {t('FR_Graph_Altitude')}
              </FormLabel>
              <RadioGroup
                aria-labelledby="altitude-radio-buttons-group-label"
                name="altitude-radio-buttons-group"
                {...getFieldProps('uniteAltitude')}
                value={getFieldProps('uniteAltitude').value || ''}
              >
                <FormControlLabel value="m" control={<Radio />} label="m" />
                <FormControlLabel value="ft" control={<Radio />} label="ft" />
              </RadioGroup>
            </FormControl>

            <FormControl fullWidth>
              <FormLabel id="distance-radio-buttons-group-label">{t('RC_Distance')}</FormLabel>
              <RadioGroup
                aria-labelledby="distance-radio-buttons-group-label"
                defaultValue="female"
                name="distance-radio-buttons-group"
                {...getFieldProps('uniteDistance')}
                value={getFieldProps('uniteDistance').value || ''}
              >
                <FormControlLabel value="km" control={<Radio />} label="km" />
                <FormControlLabel value="mille" control={<Radio />} label="NM" />
              </RadioGroup>
            </FormControl>
          </Stack>
          <LoadingButton
            fullWidth
            size="large"
            type="submit"
            variant="contained"
            loading={isSubmitting}
            startIcon={<Icon icon={saveIcon} />}
          >
            {t('btn_Save')}
          </LoadingButton>
        </Stack>
      </Form>
    </FormikProvider>
  );
}
